<div id="computer-lab" class="inner-page py-5">
  <div class="container-fluid px-lg-5">
    <h2 class="title text-uppercase mb-2">Computer Laboratories</h2>
    <p class="inner-lead mt-3">
      Shah Satnam Ji Girls' College features state-of-the-art computer laboratories designed to support the academic and research needs of students in Computer Science, IT, and related fields.
    </p>

    <hr class="divider">

    <div class="row g-4 mt-2 mb-5">
      <div class="col-md-6">
        <h4 class="section-subtitle text-success">Infrastructure & Hardware</h4>
        <ul class="inner-lead">
          <li><strong>High-Performance Systems:</strong> Equipped with the latest generation computers and high-speed peripheral devices.</li>
          <li><strong>High-Speed Connectivity:</strong> Seamless internet access throughout the labs to facilitate research, software development, and online learning.</li>
          <li><strong>UPS Backup:</strong> Uninterrupted power supply ensures that practical sessions and exams continue without disruption.</li>
        </ul>
      </div>
      <div class="col-md-6">
        <h4 class="section-subtitle text-success">Software & Learning</h4>
        <ul class="inner-lead">
          <li><strong>Programming Environments:</strong> Pre-installed environments for C, C++, Java, Python, and Web Development.</li>
          <li><strong>Specialized Tools:</strong> Digital design suites and data analysis software for advanced technical projects.</li>
          <li><strong>Focus Areas:</strong> Coding, Cybersecurity workshops, Multimedia projects, and Data Analysis.</li>
        </ul>
      </div>
    </div>

    <!-- Computer Lab Gallery Section -->
    <div class="gallery-section mt-5">
      <h3 class="gallery-title text-center mb-4">Computer Labs Showcase</h3>
      
      <div class="row g-3 justify-content-center">
        <div class="col-6 col-sm-4 col-md-3" *ngFor="let img of computerImages">
          <div class="gallery-card rounded-4 overflow-hidden position-relative shadow-sm" (click)="openLightbox(img)">
            <img [src]="img" alt="Computer Lab Environment" class="img-fluid w-100" style="object-fit: cover; height: 180px; transition: transform 0.3s ease;">
            <div class="gallery-overlay d-flex align-items-center justify-content-center">
              <span class="zoom-icon"><i class="fas fa-search-plus"></i> View Lab</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Fullscreen Backdrop-Blurred Lightbox -->
    <div class="lightbox-backdrop d-flex align-items-center justify-content-center animate-fade-in" *ngIf="activeLightboxImage" (click)="closeLightbox()">
      <div class="lightbox-content position-relative" (click)="$event.stopPropagation()">
        <button class="btn-close-lightbox" (click)="closeLightbox()">&times;</button>
        <img [src]="activeLightboxImage" class="lightbox-img img-fluid rounded-3" alt="Fullscreen Computer Lab View">
      </div>
    </div>

    <div class="mt-5 text-center">
       <p class="text-muted small"><em>Nurturing the next generation of IT professionals and digital innovators.</em></p>
    </div>

  </div>
</div>

